const en = require('./en.json');

angular.module("translations", []).config(["$translateProvider", function ($translateProvider) {
  $translateProvider.translations("en", en);
}]);